import type { CollectionsSizeSummary } from "../types/collection-types";

export function CollectionsSizeSummary({ summary }: { summary: CollectionsSizeSummary }) {
    return (
        <div className="text-sm">
            총{" "}
            <span className="font-semibold text-primary">
                {summary.total_count.toLocaleString()}
            </span>
            개의 결과 (전체 데이터 행 수:{" "}
            <span className="font-semibold text-primary">
                {summary.total_data_rows.toLocaleString()}
            </span>
            , 전체 데이터 크기:{" "}
            <span className="font-semibold text-primary">
                {summary.total_data_size_mb.toLocaleString(undefined, { maximumFractionDigits: 2 })}
            </span>
            {" "}MB)
        </div>
    );
}